export interface DataSistema{
    rowsPerPage: Array<number>
}


export interface Categoria{
    iddecinvcategoria: number,
    nombrecategoria: string,
    descripcion: string,
    activo: number,
    ncategoria: number
}

export interface GuardarCategoria{
    categoria : Categoria,
    productos: Array<number>
}

export function getCategoriaVacia(): GuardarCategoria{
    return{
        categoria: getCategoriaEmpty(),
        productos: []
    }
} 

export interface ProductoEsperado{
    activo: number
    idCategoria: number,
    idProducto: number,
    nombreCategoria: string,
    nombreProducto: string,
    ultimoCambio: Date
}

export function getCategoriaEmpty(): Categoria{
    return{
        iddecinvcategoria: 0,
        nombrecategoria:'',
        descripcion:'',
        ncategoria:0,
        activo:-1
    }
}

export interface Producto_Esperado{
    producto: string,
    categoria: string,
    activo: string
}

export interface objProductoEsperado{
    producto: Producto_Esperado,
    idprodesp: number
}

export function getProductoEmpty(): Producto_Esperado{
    return{
        producto:'',
        categoria:'-1',
        activo:'-1'
    }
}

export function getProductoVacio():objProductoEsperado{
    return{
        producto: getProductoEmpty(),
        idprodesp: 0
    }
}




